import React, { createContext, useState, useEffect } from 'react';

import { getUserFromStorage, saveUserToStorage } from '../utils/userStorage';

// SERVICES
import { loginUsuarioTienda } from '../services/usuarioTienda';
import { loginUsuario } from '../services/usuarios';

export const UserContext = createContext();

export function UserProvider({ children }) {
    const [user, setUser] = useState({});

    // Initialize cart from localStorage
    useEffect(() => {
        const initializeUser = () => {
            const savedUser = getUserFromStorage();
            setUser(savedUser || {}); // Ensure we always have an array
        };
        initializeUser();
    }, []);

    // Save to localStorage when cart changes
    // useEffect(() => {
    //     console.log("Saving user to storage:", user);
    //     saveUserToStorage(user);
    // }, [user]);

    const login = async (form, tipoUsuario) => {
        if(!form || !form.correo || !form.password) {
            return {
                status: false,
                mensaje: "Correo y contraseña son requeridos",
            };
        }

        let result = {};

        if (tipoUsuario === 'USUARIO') {
            result = await loginUsuarioTienda(form);

            if (result.status) {
                // Si el login es exitoso, guardar el usuario en el contexto
                const mockUser = {
                    id: result.usuario.id,
                    numero_cliente: result.usuario.numero_cliente,
                    nombre_pdv: result.usuario.nombre_pdv,
                    nombre_titular: result.usuario.nombre_titular,
                    calle: result.usuario.calle,
                    numero_ext: result.usuario.numero_ext,
                    colonia: result.usuario.colonia,
                    municipio: result.usuario.municipio,
                    estado: result.usuario.estado,
                    cp: result.usuario.cp,
                    latitud: result.usuario.latitud,
                    longitud: result.usuario.longitud,
                    telefono: result.usuario.telefono,
                    correo: result.usuario.correo,
                    password: result.usuario.password,
                    tipo_cliente: result.usuario.tipo_cliente,
                    lista_precios: result.usuario.lista_precios,
                    status: result.usuario.status,
                    comentario_rechazo: result.usuario.comentario_rechazo,
                    archivo_1: result.usuario.archivo_1,
                    archivo_2: result.usuario.archivo_2,
                    archivo_3: result.usuario.archivo_3,
                    archivo_4: result.usuario.archivo_4,
                    id_vendedor: result.usuario.id_vendedor,
                    tipoUsuario: 'USUARIO',
                    id_crm: result.usuario.id_crm,
                    token: result.token,
                };
                setUser(mockUser);
                saveUserToStorage(mockUser);

                return {
                    status: true,
                    mensaje: "Inicio de sesión exitoso",
                };
            } 
        } else if (tipoUsuario === 'ADMINISTRADOR') {
            result = await loginUsuario(form);

            if (result.status) {
                // Si el login es exitoso, guardar el usuario en el contexto
                const mockUser = {
                    id: result.usuario.pk,
                    nombre: result.usuario.fields.nombre,
                    apellido: result.usuario.fields.apellido,
                    usuario: result.usuario.fields.usuario,
                    puesto: result.usuario.fields.puesto,
                    foto: result.usuario.fields.foto,
                    nip: result.usuario.fields.nip,
                    correo: result.usuario.fields.correo,
                    notas: result.usuario.fields.notas,
                    nombre_completo: result.usuario.fields.nombre_completo,
                    empresa: result.usuario.fields.empresa,
                    tel_movil: result.usuario.fields.tel_movil,
                    region: result.usuario.fields.region,
                    fecha_nacimiento: result.usuario.fields.fecha_nacimiento,
                    estado: result.usuario.fields.estado,
                    numero_empleado: result.usuario.fields.numero_empleado,
                    nivel_usuario: result.usuario.fields.nivel_usuario,
                    cuenta: result.usuario.fields.cuenta,
                    en_reporte: result.usuario.fields.en_reporte,
                    tipoUsuario: 'ADMINISTRADOR',
                    token: result.token,
                };
                setUser(mockUser);
                saveUserToStorage(mockUser);

                return {
                    status: true,
                    mensaje: "Inicio de sesión exitoso",
                };
            }
        }
        else {
            return {
                status: false,
                mensaje: "Tipo de usuario no soportado",
            };
        }

        return result;
    };

    const logout = () => {
        setUser({});
        saveUserToStorage({});
    };

    const isLoggedIn = () => {
        return !!user.token; // Verifica si hay un token de usuario
    }

    const typeUser = user.tipoUsuario || null;

    return <UserContext.Provider
                value={{
                    user,
                    typeUser,
                    login,
                    logout,
                    isLoggedIn,
                }}
            >
                {children}
            </UserContext.Provider>;
}
